import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { styled } from "styled-components";
import { WebAppTheme } from "../../types/web";
import createCSSVars from "../../utils/createCSSVars";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  overflow: scroll;
  background: #e2e2e2;
  padding: 20px;
  flex-wrap: wrap;
  height: calc(100vh - 101px);
`;

export default function WebEmbedder() {
  const iframeRef = React.useRef<HTMLIFrameElement>(null);
  const { watch } = useFormContext<WebAppTheme>();
  const theme = watch();

  useEffect(() => {
    const cssVariables = createCSSVars(theme);

    // Apply css variable to iframe
    if (iframeRef.current) {
      iframeRef.current.contentWindow?.postMessage(
        {
          type: "CHANGE_CSS_VARIABLES",
          payload: cssVariables,
        },
        "*"
      );
    }

    // Apply css variable same document
    const root = document.documentElement;
    Object.keys(cssVariables).forEach(key => {
      root.style.setProperty(key, cssVariables[key]);
    });
  }, [theme]);

  return (
    <Container>
      <iframe
        title="OrderWeb White Label"
        ref={iframeRef}
        src="https://holygreens-alpha.ancon.io/"
        width={"100%"}
        height={"100%"}
      />
    </Container>
  );
}
